import baseFetch from '../baseFetch';

export const getTopSpots = async (
  geonameId: string | string[] | undefined,
  cookies: any,
  includeLineupCams = false,
  includeInternalCams = false,
) =>
  baseFetch(
    `/kbyg/spots/topspots?id=${geonameId}&type=geoname${includeLineupCams ? '&includeLineupCams=true' : ''}${includeInternalCams ? '&includeInternalCams=true' : ''}`,
    { cookies },
  );
